import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading, checkAuth } = useAuth();

  // LE FILET. Un cookie de session peut exister sans que le contexte le
  // sache : posé par une réponse JSON (`/intake/start`, `/intake/verify`)
  // que personne n'a relayée, ou par un onglet voisin. Avant de renvoyer
  // quelqu'un sur /login, on relit `/auth/me` UNE fois. Si le cookie est
  // bon, la page s'ouvre ; sinon la redirection reste ce qu'elle était.
  // Une seule relecture : un vrai anonyme ne boucle pas.
  const [retried, setRetried] = useState(false);
  const [retrying, setRetrying] = useState(false);
  useEffect(() => {
    if (loading || user || retried || retrying) return undefined;
    let cancelled = false;
    setRetrying(true);
    Promise.resolve(checkAuth?.()).catch(() => {}).finally(() => {
      if (cancelled) return;
      setRetried(true);
      setRetrying(false);
    });
    return () => { cancelled = true; };
  }, [loading, user, retried, retrying, checkAuth]);

  // LE LAISSEZ-PASSER `location.state.user` A ÉTÉ SUPPRIMÉ LE 19/08/2026.
  //
  // Trois lignes rendaient les enfants SANS aucune vérification dès que
  // l'état de navigation portait un objet `user`. Elles existaient pour
  // un seul appelant, `AuthCallback`, qui poussait le profil rendu par
  // le courtier Emergent afin d'éviter un aller-retour `/auth/me` — et
  // cet appelant a disparu avec le courtier.
  //
  // Ce n'était pas une porte dérobée sur les DONNÉES : l'API exige le
  // cookie de session à chaque appel, et un écran ouvert de force
  // n'aurait affiché que des 401. Mais `navigate('/dashboard', { state:
  // { user: {} } })` suffisait à faire peindre l'intérieur de l'app à
  // quelqu'un qui n'est pas connecté, et c'est le genre de raccourci
  // qu'on ne garde pas une fois son unique raison d'être partie.

  if (loading || retrying || (!user && !retried)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f8f8f8]">
        <div className="text-center">
          <div className="w-10 h-10 border-2 border-[#1a56db] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
